import $ from "jquery";
import plugin from "@core/plugins/lib";
import debug from 'debug';

const log = debug('core/components/site-header/alert');

const ELEMENT_SELECTOR = "[data-site-alert]";

class SiteAlert {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		this.dismissButton = document.querySelector(
			this.options.dismissButtonSelector
		);

		this.watch();
	}

	watch() {
		this.dismissButton.addEventListener(
			"click",
			this.dismiss.bind(this)
		);
	}

	dismiss() {
		$(this.element).remove();
		$.get(this.options.cookieEndpoint, (data)=>{
			log(data);
		});
	}

}

SiteAlert.DEFAULTS = {};

plugin("siteAlert", SiteAlert);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)["siteAlert"]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/site-header/alert/site-alert.js